var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorShower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.197,
    cy: 23.43,
    r: 0.479
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.197,
    cy: 28.494,
    r: 0.479
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.197,
    cy: 33.558,
    r: 0.479
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.197,
    cy: 38.621,
    r: 0.479
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.836,
    cy: 23.43,
    r: 0.479
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.228,
    cy: 28.479,
    r: 0.479
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.619,
    cy: 33.527,
    r: 0.479
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.011,
    cy: 38.576,
    r: 0.479
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.476,
    cy: 23.43,
    r: 0.479
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.58,
    cy: 28.372,
    r: 0.479
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.684,
    cy: 33.314,
    r: 0.479
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.788,
    cy: 38.256,
    r: 0.479
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.164,
    cy: 23.43,
    r: 0.479
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.772,
    cy: 28.479,
    r: 0.479
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.381,
    cy: 33.527,
    r: 0.479
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.989,
    cy: 38.576,
    r: 0.479
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.524,
    cy: 23.43,
    r: 0.479
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.42,
    cy: 28.372,
    r: 0.479
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.316,
    cy: 33.314,
    r: 0.479
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.212,
    cy: 38.256,
    r: 0.479
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.604,9.406h-3.37v-5.051c0-.804-.652-1.455-1.455-1.455s-1.455.652-1.455,1.455v5.051h-2.928c-4.456,0-8.067,3.612-8.067,8.067h0s25.343,0,25.343,0h0c0-4.456-3.612-8.067-8.067-8.067Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorShower);
export default __webpack_public_path__ + "static/media/indoor-shower.a45a6cbc0a1545fd72af073267674747.svg";
export { ForwardRef as ReactComponent };